import React, { useState } from 'react';
import classes from './TimePickerInput.module.css';
// import TimePicker from 'react-time-picker';
import { clsx } from 'clsx';
import { AlaramIcon } from '../../../Assets/icons';
import { Calendar } from 'primereact/calendar';
const TimePickerInput = ({
  value,
  setter,
  id,
  label,
  className,
  parentStyles,
  errorText,
  isOptional,
  ...rest
}) => {
  const [time, setTime] = useState();
  return (
    <div
      className={clsx(classes.wrapper, className, {
        [classes.error]: errorText
      })}
      style={parentStyles}>
      {label && (
        <label htmlFor="" className={classes.labelText}>
          {label} {!isOptional && <span className={'steric'}>*</span>}
        </label>
      )}
      <div className={classes.container}>
        {/* <TimePicker
          id={id}
          style={{
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            fontSize: '14px'
          }}
          value={value}
          onChange={(e) => {
          
            setter(e);
          }}
          {...rest}
          PopperProps={{
            modifiers: [
              {
                name: 'flip',
                enabled: false // Disables automatic flipping of the dropdown
              },
              {
                name: 'offset',
                options: {
                  offset: [0, -10] // Adjusts the dropdown position upwards
                }
              }
            ]
          }}
        /> */}
        {/* <Calendar id="calendar-timeonly" value={value} onChange={(e) => setter(e.value)} timeOnly /> */}
        <Calendar
          id="calendar-timeonly"
          placeholder="hh:mm AM/PM"
          value={value}
          onChange={(e) => setter(e?.value)}
          hourFormat="12"
          timeOnly
        />
        <span className={classes.clockIcon}>
          <AlaramIcon size={20} color="var(--icon-color)" />
        </span>
      </div>
    </div>
  );
};

export default TimePickerInput;
